<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="25">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getMainTableRecords"
                    :table-search="mainTable.tableSearch"
                    :colSpan="4" />
                </Col>
            </Row>
        </transition>

        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="25">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">定金单管理</span>
						<span style="margin-left:20px;">会员类别:</span>
						<RadioGroup v-model="userType"
						    style="margin-left:4px;"
						    @on-change="onUserTypeChage">
						    <Radio label="F"> <span>外部会员</span></Radio>
						    <Radio label="E"> <span>内部会员</span></Radio>
						</RadioGroup>
                    </div>
                    <div class="right-bar">
                        <Button type="info"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-send"
                            :loading="btnLoading"
                            @click="onExport()">导出</Button>

                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="25">
                <stand-pagination-table :columns="mainTable.tableColumns"
                    :data="mainTable.tableData"
                    :extHeight="60"
                    :loading="mainTable.tableLoading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Card>

        <AddOrUpdate ref="addOrUpdateRef" />
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import { dateTimeRender, dateRender } from '@/libs/tableRowTimeRender';
import AddOrUpdate from './add-or-update';
import { exportPreSaleOrderList } from '@/api/modules/preSale-management/preSale-order';
import { getNoPaidDepositBillOrderList, cancelDepositBillByUuid } from '@/api/modules/preSale-management/deposit-order';
import { getNoPaidDepositStatusOptions } from '@/view/preSale-management/preSale-order/PreSaleOrderStatus';
import { numberToFixed } from '@/components/number-input/display-format';
import { DOWNLOAD_SERVER } from '@/api/modules/files';
import { SignContractForUser } from '@/api/modules/system-management/user-management';

export default {
    name: 'NoPaidDepositBillOrderList',
    components: {
        StandPaginationTable,
        SearchCard,
        AddOrUpdate
    },
    data() {
        return {
            userType:'F',
            btnLoading: false,
            mainTable: {
                tableColumns: [
                    { title: '定金单编号', key: 'depositBillRecordCode', align: 'center', excel: true },
                    { title: '关联销售单编号', key: 'depositBillRecordRelatepreSaleOrderRecordCode', align: 'center', excel: true },
                    { title: '会员名称', key: 'userPersonName', align: 'center', excel: true },
                    { title: '会员账号', key: 'userName', align: 'center', excel: true },
                    { title: '会员电话', key: 'userPhone', align: 'center', excel: true },
                    { title: '客户经理', key: 'customerManagername', align: 'center', excel: true },
                    { title: '定单合计', key: 'depositBillRecordTotalProductCost', align: 'center', excel: true,
                        render: (h, params) => {
                            return h('span', parseFloat(params.row.depositBillRecordTotalProductCost.toFixed(2)));
                        }
                    },
                    { title: '佣金比例(%)', key: 'salesAssociateCommissionPercent', align: 'center', excel: true },
                    { title: '应付定金', key: 'depositBillRecordDepositPaymentSum', align: 'center', excel: true },
                    { title: '定金单状态', key: 'depositBillRecordOrderStatus', align: 'center', excel: true },
                    { title: '支付状态', key: 'depositBillRecordPaidStatus', align: 'center', excel: true },
                    { title: '定单周期', key: 'weekDesc', align: 'center', excel: true },
                    { title: '发货日期', key: 'depositBillRecordSendProductDate', sortable: true, excel: true, align: 'center', render: (h, params) => dateRender(h, params.row.depositBillRecordSendProductDate) },
                    { title: '下单时间', key: 'depositBillRecordCreateAt', sortable: true, align: 'center', excel: true, render: (h, params) => dateTimeRender(h, params.row.depositBillRecordCreateAt) },
                    { title: '客户备注', key: 'customerMsg', align: 'center', excel: true },
                    { title: '定单备注', key: 'orderRemark', align: 'center', excel: true },
                    {
					    title: '定购协议',
					    key: 'action3',
					    align: 'center',
					    render: (h, params) => {
					        if (params.row.action === -1) {
					            return "";
					        }
					        else {
					            return h('div', [
					                h('Button', {
					                    props: {
					                        type: 'text',
					                        size: 'small',
					                        shape: 'circle',
                                            disabled:this.btndownLoading
					                    },
                                        style:{
                                            visibility: params.row.customerManagername=='合计'? 'hidden' : 'visible'
                                        },
					                    on: {
					                        click: () => {
					                            this.onSignContract(params.row.depositBillRecordUuid);
					                        }
					                    }
					                }, '下载')
					            ]);
					        }
					    }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.action === -1) {
                                return "";
                            }
                            else {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style:{
                                            visibility: params.row.customerManagername=='合计'? 'hidden' : 'visible'
                                        },
                                        on: {
                                            click: () => {
                                                this.$refs.addOrUpdateRef.showModal(params.row.depositBillRecordUuid);
                                            }
                                        }
                                    }, '查看'),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style:{
                                            display: (
                                                this.$checkAccessArray(['B', 'C', 'S']) && !params.row.depositBillRecordOrderStatus == '取消' ? 'inline' : 'none')
                                        },
                                        on: {
                                            click: () => {
                                                this.cancalOrder(params.row.depositBillRecordUuid);
                                            }
                                        }
                                    }, '取消')
                                ]);
                            }
                        }
                    }
                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: true,
                searchForm: [
                    { label: '定金单编号', type: 'Input', value: '', name: 'depositBillRecordCode', sql: 'like' },
                    { label: '销售单编号', type: 'Input', value: '', name: 'depositBillRecordRelatepreSaleOrderRecordCode', sql: 'like' },
                    { label: '会员信息', type: 'Input', value: '', name: 'concat(userPersonName,userName,userPhone)', sql: 'like' },
                    { label: '下单时间', type: 'Daterange', value: '', name: 'depositBillRecordCreateAt', sql: 'dateBetween' },
                    { label: '发货日期', type: 'Daterange', value: '', name: 'depositBillRecordSendProductDate', sql: 'dateBetween' },
                    {
					    label: '待支付定单状态',
					    type: 'Select',
					    value: [],
					    name: 'depositBillRecordOrderStatus',
					    sql: 'in',
					    options: getNoPaidDepositStatusOptions()
                    },
                    { label: '订单周次', type: 'Input', value: '', name: 'preSaleOrderDetailWeekKnownText', sql: 'like' }
                ]
            },
            btndownLoading: false
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.getMainTableRecords();
        },
        onSignContract(orderUuid) {
            if(this.btndownLoading == true){
                return;
            }
		    this.mainTable.tableLoading = true;
            this.btndownLoading = true;
		    SignContractForUser({
		        orderUuid: orderUuid,
		        shoppingType: '预售'
		    }).then(res => {
		        this.mainTable.tableLoading = false;
                this.btndownLoading = false;
		        if (res.code === 0) {
		            if (res.code === 0) {
		                window.open(res.data.signResult, "_blank");
		            }
		        }
		    });
        },
        cancalOrder(recordUuid){
        	this.$Modal.confirm({
        		  title: "是否确认取消该待支付订单？",
        		  content: "",
        		  onOk: async () => {
        			  this.mainTable.loading = true;
        			  cancelDepositBillByUuid({ depositBillRecordUuid:recordUuid }).then(res => {
        				  this.mainTable.loading = false;
        				  if (res.code === 0) {
        					  this.getMainTableRecords();
        					  this.$Message.success('成功取消该待支付订单！');
        				  }
                        else{
                            this.$Message.error(res.message);
                        }
        			  });
        		  }
        	});
        },
        onExport() {
            this.mainTable.tableLoading = true;
            this.btnLoading = true;
            this.mainTable.tableSearch.excelExport.enable = true;
            getNoPaidDepositBillOrderList(this.mainTable.tableSearch).then(res => {
                this.btnLoading = false;
                this.mainTable.tableLoading = false;
                if (res.code === 0) {
                    if (res.code === 0) {
                        let url = DOWNLOAD_SERVER + res.data.exportFileName;
                        this.$downLoadFile(url);
                    }
                }
            });
        },
        onUserTypeChage(){
            this.getMainTableRecords();
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            if (this.userType) {
                search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "memberType");
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: 'memberType',
                    type: 'eq',
                    value: this.userType
                });
            }
            getNoPaidDepositBillOrderList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records;
                    let depositBillRecordTotalOrderCostTotal = 0;
                    let depositBillRecordDepositPaymentSumTotal = 0;

                    this.mainTable.tableData.forEach(e => {
                        depositBillRecordTotalOrderCostTotal += e.depositBillRecordTotalProductCost;
                        depositBillRecordDepositPaymentSumTotal += e.depositBillRecordDepositPaymentSum;
                    });
                    this.mainTable.tableData.push({
                        customerManagername: '合计',
                        depositBillRecordTotalProductCost: numberToFixed(depositBillRecordTotalOrderCostTotal, 2),
                        depositBillRecordDepositPaymentSum: numberToFixed(depositBillRecordDepositPaymentSumTotal, 2),
                        action: 1
                    });
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }
                this.mainTable.tableLoading = false;
            });
        }
    }
};
</script>

<style scoped>
</style>
